export default __webpack_public_path__ + "static/media/confirmed.49f55254.svg";